<script lang="ts">
import type { Filter } from '@nuxtDatakodeUtils/types/Api/Response/Filter'
import type { IndexMeta } from '@nuxtDatakodeUtils/types/Api/Response/IndexMeta'
import type { FilterType } from '@nuxtDatakodeUtils/types/Api/Response/Filter.type'
import ListData = App.Data.ListData

export default {
    name: 'FiltersTemplate',
    props: {
        meta: { type: Object, required: true },
        translationName: { type: String, required: true },
        filters: { type: Array<FilterType>, required: true },
    },
    emits: ['setQuery', 'resetQuery'],
    data() {
        return {
            show: false,
        }
    },
    methods: {
        filterValue(key: string) {
            return this.meta.request.filter[key]
        },
        showFilterValue(filter: Filter, value: any) {
            // TODO handle daterange
            // TODO handle range
            // move to filter service

            if (filter.availableOperators && typeof value === 'object') {
                return Object.keys(value)
                    .map((operator) => {
                        return `${this.$translate(`operators.${operator}`)} ${value[operator]}`
                    })
                    .join(' ET ')
            }

            if (typeof value === 'string') {
                const key = `${this.translationName}.${filter.name}.${value}`
                const sanitizedKey = key.replace(/[^\w|.$]/g, '')
                const trad = this.$translate(key)
                if (trad !== key && trad !== sanitizedKey) {
                    return trad
                }
                else {
                    return value
                }
            }

            // handle list data
            return (value as ListData).v
        },
        clearItem(filter: Filter, value: any) {
            const filters = {}
            const meta = this.meta as IndexMeta
            meta.allowed_filters.forEach((filterItem: Filter) => {
                if (filterItem.is_active) {
                    const values = filterItem.active_values
                        .filter(v => v !== value)
                        .map(v => (typeof v === 'string') ? v : v.k)
                    if (values.length) {
                        filters[filterItem.name] = values.join(',')
                    }
                }
            })
            this.$emit('setQuery', filters)
        },
    },
}
</script>

<template>
    <div class="d-lg-flex d-block">
        <v-btn class="ma-2" prepend-icon="mdi-filter" variant="outlined" color="primary" @click="show = !show">
            Filtrer les colonnes
        </v-btn>
        <v-btn class="ma-2" variant="outlined" color="primary" @click.prevent="$emit('resetQuery')">
            Réinitialiser les filtres
        </v-btn>
        <v-spacer />
        <slot name="moreButtons" />
    </div>
    <v-expand-transition>
        <v-card v-show="show" class="mb-4">
            <v-card-text>
                <slot name="filters" />
                <v-btn color="primary" block class="mt-4" @click.prevent="$emit('setQuery')">
                    Rechercher
                </v-btn>
            </v-card-text>
        </v-card>
    </v-expand-transition>

    <div v-if="filters">
        <template v-for="filter in filters" :key="filter.name">
            <template v-if="filter.is_active">
                <v-chip
                    v-for="filter_value in filter.active_values"
                    :key="filter_value"
                    class="mr-2 mb-2"
                    closable
                    @click:close="clearItem(filter, filter_value)"
                >
                    {{ $translate(`${translationName}.${filter.name}`) }} :
                    <span class="font-weight-bold ml-1">
                        {{ showFilterValue(filter, filter_value) }}
                    </span>
                </v-chip>
            </template>
        </template>
    </div>
</template>
